import { IEvaluationCommand } from "@Evaluation/cqrs";
import { EstimationsVote } from "@Evaluation/Model";

export class CreatePanelCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.Estimations.Commands.CreatePanelCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	Id: string;
	EvalModelId: number;
	Name: string;
	Description: string;
	OwnerEmail: string;
	ResponseDueDateIsoString: string | null;

	constructor(workspaceId: number, surveyId: number, evalModelId: number, name: string, description: string, ownerEmail: string, responseDueDateIsoString: string | null)
	{
		this.WorkspaceId = workspaceId;
		this.Id = surveyId.toString();
		this.EvalModelId = evalModelId;
		this.Name = name;
		this.Description = description;
		this.OwnerEmail = ownerEmail;
		this.ResponseDueDateIsoString = responseDueDateIsoString;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.Estimations.Commands.CreatePanelCommandV1, TCh.Domain.Evaluation'
	}
}

export class UpdatePanelCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.Estimations.Commands.UpdatePanelCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	Id: string;
	EvalModelId: number;
	Name: string;
	Description: string;
	OwnerEmail: string;
	ResponseDueDateIsoString: string | null;

	constructor(workspaceId: number, surveyId: number, evalModelId: number, name: string, description: string, ownerEmail: string, responseDueDateIsoString: string | null)
	{
		this.WorkspaceId = workspaceId;
		this.Id = surveyId.toString();
		this.EvalModelId = evalModelId;
		this.Name = name;
		this.Description = description;
		this.OwnerEmail = ownerEmail;
		this.ResponseDueDateIsoString = responseDueDateIsoString;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.Estimations.Commands.UpdatePanelCommandV1, TCh.Domain.Evaluation'
	}
}

export class ClonePanelCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.Estimations.Commands.ClonePanelCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	Id: string;
	CloneName: string;

	constructor(workspaceId: number, surveyId: number, cloneName: string)
	{
		this.WorkspaceId = workspaceId;
		this.Id = surveyId.toString();
		this.CloneName = cloneName;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.Estimations.Commands.ClonePanelCommandV1, TCh.Domain.Evaluation'
	}
}

export class DeletePanelCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.Estimations.Commands.DeletePanelCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	Id: string;

	constructor(workspaceId: number, surveyId: number)
	{
		this.WorkspaceId = workspaceId;
		this.Id = surveyId.toString();
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.Estimations.Commands.DeletePanelCommandV1, TCh.Domain.Evaluation'
	}
}

export class OpenPanelAccessCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.Estimations.Commands.OpenPanelAccessCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	Id: string;

	constructor(workspaceId: number, surveyId: number)
	{
		this.WorkspaceId = workspaceId;
		this.Id = surveyId.toString();
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.Estimations.Commands.OpenPanelAccessCommandV1, TCh.Domain.Evaluation'
	}
}

export class ClosePanelAccessCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.Estimations.Commands.ClosePanelAccessCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	Id: string;

	constructor(workspaceId: number, surveyId: number)
	{
		this.WorkspaceId = workspaceId;
		this.Id = surveyId.toString();
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.Estimations.Commands.ClosePanelAccessCommandV1, TCh.Domain.Evaluation'
	}
}

export class UpdatePanelAlternativesSettingsCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.Estimations.Commands.UpdatePanelAlternativesSettingsCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	Id: string;
	RespondentsAttributeId: number;
	AlternativesViewDefinitionId: string;
	AlternativeDescriptionTemplate: string;

	constructor(workspaceId: number, surveyId: number, respondentsAttributeId: number, viewDefId: string, descriptionTemplate: string)
	{
		this.WorkspaceId = workspaceId;
		this.Id = surveyId.toString();
		this.RespondentsAttributeId = respondentsAttributeId;
		this.AlternativesViewDefinitionId = viewDefId;
		this.AlternativeDescriptionTemplate = descriptionTemplate;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.Estimations.Commands.UpdatePanelAlternativesSettingsCommandV1, TCh.Domain.Evaluation'
	}
}

export class UpdatePanelAttributesSettingsCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.Estimations.Commands.UpdatePanelAttributesSettingsCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	Id: string;
	SelectedAttributesIds: number[];

	constructor(workspaceId: number, surveyId: number, selectedAttributesIds: number[])
	{
		this.WorkspaceId = workspaceId;
		this.Id = surveyId.toString();
		this.SelectedAttributesIds = selectedAttributesIds;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.Estimations.Commands.UpdatePanelAttributesSettingsCommandV1, TCh.Domain.Evaluation'
	}
}


export class UpdateAlternativesCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.Estimations.Commands.UpdateAlternativesCommandV1, TCh.Domain.Evaluation';

	UserId: number;
	WorkspaceId: number;
	Id: string;

	constructor(userId: number, workspaceId: number, surveyId: number)
	{
		this.UserId = userId;
		this.WorkspaceId = workspaceId;
		this.Id = surveyId.toString();
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.Estimations.Commands.UpdateAlternativesCommandV1, TCh.Domain.Evaluation'
	}
}



export class SendEmailCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.Estimations.Commands.SendEmailCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	Id: string;
	ProjectUsersIds: number[];
	EmailSubject: string;
	EmailBody: string;
	

	constructor(workspaceId: number, surveyId: number, projectUsersIds: number[], emailSubject: string, emailBody: string)
	{
		this.WorkspaceId = workspaceId;
		this.Id = surveyId.toString();
		this.ProjectUsersIds = projectUsersIds;
		this.EmailSubject = emailSubject;
		this.EmailBody = emailBody;
	}

	static matchType(cmd: IEvaluationCommand)	{
		return cmd.$type == 'TCh.Domain.Evaluation.Estimations.Commands.SendEmailCommandV1, TCh.Domain.Evaluation'
	}
}

export class UpdatePanelistAlternativesCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.Estimations.Commands.UpdatePanelistAlternativesCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	Id: string;
	ProjectUserId: number;
	SelectedIds: number[];

	constructor(workspaceId: number, surveyId: number, projectUserId: number, selectedIds: number[])
	{
		this.WorkspaceId = workspaceId;
		this.Id = surveyId.toString();
		this.ProjectUserId = projectUserId;
		this.SelectedIds = selectedIds;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.Estimations.Commands.UpdatePanelistAlternativesCommandV1, TCh.Domain.Evaluation'
	}
}

export class IncludePanelistCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.Estimations.Commands.IncludePanelistCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	Id: string;
	ProjectUserId: number;

	constructor(workspaceId: number, surveyId: number, projectUserId: number)
	{
		this.WorkspaceId = workspaceId;
		this.Id = surveyId.toString();
		this.ProjectUserId = projectUserId;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.Estimations.Commands.IncludePanelistCommandV1, TCh.Domain.Evaluation'
	}
}

export class ExcludePanelistCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.Estimations.Commands.ExcludePanelistCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	Id: string;
	ProjectUserId: number;

	constructor(workspaceId: number, surveyId: number, projectUserId: number)
	{
		this.WorkspaceId = workspaceId;
		this.Id = surveyId.toString();
		this.ProjectUserId = projectUserId;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.Estimations.Commands.ExcludePanelistCommandV1, TCh.Domain.Evaluation'
	}
}


export class SaveGroupVoteCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.Estimations.Commands.SaveGroupVoteCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	Id: string;
	QuestionId: string;
	Comment: string;
	Value: number;

	constructor(workspaceId: number, surveyId: number, questionId: string, value: number, comment: string)
	{
		this.WorkspaceId = workspaceId;
		this.Id = surveyId.toString();
		this.QuestionId = questionId;
		this.Comment = comment;
		this.Value = value;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.Estimations.Commands.SaveGroupVoteCommandV1, TCh.Domain.Evaluation'
	}
}

export class SaveGroupCommentCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.Estimations.Commands.SaveGroupCommentCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	Id: string;
	QuestionId: string;
	Comment: string;

	constructor(workspaceId: number, surveyId: number, questionId: string, comment: string)
	{
		this.WorkspaceId = workspaceId;
		this.Id = surveyId.toString();
		this.QuestionId = questionId;
		this.Comment = comment;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.Estimations.Commands.SaveGroupCommentCommandV1, TCh.Domain.Evaluation'
	}
}

export class SavePanelistVoteCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.Estimations.Commands.SavePanelistVoteCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	Id: string;
	ProjectUserId: number;
	QuestionId: string;
	Comment: string;
	Value: number;

	constructor(workspaceId: number, surveyId: number, projectUserId: number, questionId: string, value: number, comment: string)
	{
		this.WorkspaceId = workspaceId;
		this.Id = surveyId.toString();
		this.ProjectUserId = projectUserId;
		this.QuestionId = questionId;
		this.Comment = comment;
		this.Value = value;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.Estimations.Commands.SavePanelistVoteCommandV1, TCh.Domain.Evaluation'
	}
}

export class SavePanelistCommentCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.Estimations.Commands.SavePanelistCommentCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	Id: string;
	ProjectUserId: number;
	QuestionId: string;
	Comment: string;

	constructor(workspaceId: number, surveyId: number, projectUserId: number, questionId: string, comment: string)
	{
		this.WorkspaceId = workspaceId;
		this.Id = surveyId.toString();
		this.ProjectUserId = projectUserId;
		this.QuestionId = questionId;
		this.Comment = comment;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.Estimations.Commands.SavePanelistCommentCommandV1, TCh.Domain.Evaluation'
	}
}

export class SavePanelistVotesCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.Estimations.Commands.SavePanelistVotesCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	Id: string;
	ProjectUserId: number;
	AlternativeId: number;
	Votes: EstimationsVote[];

	constructor(workspaceId: number, surveyId: number, projectUserId: number, alternativeId: number, votes: EstimationsVote[])
	{
		this.WorkspaceId = workspaceId;
		this.Id = surveyId.toString();
		this.ProjectUserId = projectUserId;
		this.AlternativeId = alternativeId;
		this.Votes = votes;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.Estimations.Commands.SavePanelistVotesCommandV1, TCh.Domain.Evaluation'
	}
}



